/**
 * cn — className utility
 * Merges Tailwind classes safely with clsx + tailwind-merge.
 *
 * @example
 *   cn('px-4 py-2', active && 'bg-brand-btn', className)
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
